import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { ChatSezione } from "@/components/site/ChatSezione";
import { Marquee } from "@/components/site/Marquee";
import { Servizi } from "@/components/site/Servizi";
import { Citta } from "@/components/site/Citta";
import { ComeFunziona } from "@/components/site/ComeFunziona";
import { Faq } from "@/components/site/Faq";
import { Contatti } from "@/components/site/Contatti";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";

export default function Home() {
  useEffect(() => {
    document.title = "SOS Riparazioni 24 — Pronto Intervento Multiservizio H24";
  }, []);

  return (
    <div className="min-h-screen bg-obsidian" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <ChatSezione />
        <Marquee />
        <Servizi />
        <Citta />
        <ComeFunziona />
        <Faq />
        <Contatti />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
